import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from './Icons';
export function RevelationSection() {
  const voices = [{
    anxiety: '"Eres un desastre total"',
    spirit: '"Este hábito específico te está haciendo daño — trabajémoslo juntos"'
  }, {
    anxiety: 'Vaga y condenatoria',
    spirit: 'Específica y esperanzadora'
  }, {
    anxiety: 'Te empuja con pánico',
    spirit: 'Te atrae con gentileza'
  }, {
    anxiety: 'Destruye tu identidad',
    spirit: 'La llama a su versión más verdadera'
  }, {
    anxiety: 'Recuerda lo perdonado para avergonzarte',
    spirit: 'Recuerda lo perdonado para mostrarte cuánto te ha liberado'
  }];
  return <section className="bg-olive text-cream py-24 px-4 relative overflow-hidden" data-id="element-256">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" data-id="element-257" />

      <div className="max-w-5xl mx-auto" data-id="element-258">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-259">
          <EyeIcon className="w-12 h-12 text-gold mx-auto mb-6" data-id="element-260" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8" data-id="element-261">
            El Gran Engaño
          </h2>
          <div className="grid md:grid-cols-2 gap-8 text-left max-w-4xl mx-auto mb-16" data-id="element-262">
            <div className="bg-olive-dark p-8 rounded-lg border border-white/5" data-id="element-263">
              <h3 className="text-accent-red font-bold uppercase tracking-wider mb-4 text-sm" data-id="element-264">
                La religión te dice:
              </h3>
              <p className="font-serif text-2xl italic" data-id="element-265">
                "Ora más. Sirve más. Da más. Mejora más."
              </p>
            </div>
            <div className="bg-olive-light p-8 rounded-lg border border-gold/30 shadow-[0_0_30px_rgba(197,165,90,0.1)]" data-id="element-266">
              <h3 className="text-gold font-bold uppercase tracking-wider mb-4 text-sm" data-id="element-267">
                Cristo te dice:
              </h3>
              <p className="font-serif text-2xl italic" data-id="element-268">
                "Ven a mí tal como eres. Caminemos juntos."
              </p>
            </div>
          </div>

          <div className="max-w-3xl mx-auto text-lg space-y-6 text-cream/90 mb-16" data-id="element-269">
            <p data-id="element-270">
              La Biblia no es un manual de instrucciones para resolver
              problemas.{' '}
              <strong className="text-gold" data-id="element-271">
                Es una carta de amor que revela un Carácter.
              </strong>
            </p>
            <p data-id="element-272">
              Su propósito principal no es decirte qué hacer... sino mostrarte
              quién está contigo mientras lo haces.
            </p>
            <p className="text-xl font-serif mt-8" data-id="element-273">
              Y hay una diferencia crucial entre las dos voces que compiten en
              tu mente:
            </p>
          </div>
        </motion.div>

        <div className="space-y-4 max-w-4xl mx-auto mb-16" data-id="element-274">
          <div className="hidden md:grid grid-cols-2 gap-6 px-6 pb-2 border-b border-white/10 text-sm font-bold tracking-wider uppercase" data-id="element-275">
            <div className="text-accent-red/80" data-id="element-276">La Voz de la Ansiedad</div>
            <div className="text-gold" data-id="element-277">La Voz del Espíritu Santo</div>
          </div>

          {voices.map((voice, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="grid md:grid-cols-2 gap-4 md:gap-6 bg-olive-dark/50 p-6 rounded-lg border border-white/5 hover:border-gold/30 transition-colors" data-id="element-278">
              <div data-id="element-279">
                <span className="md:hidden text-xs font-bold text-accent-red/80 uppercase block mb-2" data-id="element-280">
                  La Voz de la Ansiedad
                </span>
                <p className="text-cream/70" data-id="element-281">{voice.anxiety}</p>
              </div>
              <div data-id="element-282">
                <span className="md:hidden text-xs font-bold text-gold uppercase block mb-2" data-id="element-283">
                  La Voz del Espíritu Santo
                </span>
                <p className="text-cream font-medium" data-id="element-284">{voice.spirit}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center max-w-3xl mx-auto" data-id="element-285">
          <p className="font-serif text-2xl italic text-gold mb-6" data-id="element-286">
            "Ya no hay ninguna condenación para los que están en Cristo Jesús."
            — Romanos 8:1
          </p>
          <p className="text-lg text-cream/90" data-id="element-287">
            Esta distinción lo cambia todo. Y es exactamente lo que aprenderás a
            aplicar.
          </p>
        </motion.div>
      </div>
    </section>;
}